///include /assets/js/app/p/checkout.js
class CheckoutPayPal extends CheckoutDriver {
    get requiresImmediateSelection() {
        return false
    }
}

CheckoutDriver.byName.paypal = CheckoutPayPal